import { z } from 'zod';
/** The audition domain vocabulary, from Part C of the platform spec. */
export const AuditionStatus = z.enum([
    'draft', 'open', 'closed', 'adjudicating', 'in_review',
    'signed_off', 'released', 'complete',
]);
export const PanelStatus = z.enum([
    'open', 'adjudicating', 'in_review', 'changes_requested', 'approved',
]);
export const SectionStatus = z.enum([
    'setup', 'open', 'adjudicating', 'in_review', 'approved',
    'offers_out', 'set', 'ordering_published',
]);
/**
 * `part_and_score` is the ONLY thing that makes a score field appear or a score
 * column be written. Nothing keys off the word "percussion".
 */
export const Scoring = z.enum(['part', 'part_and_score']);
export const Category = z.enum(['first_choice', 'reserve', 'not_selected']);
export const Outcome = z.enum(['selected', 'reserve', 'rejected']);
export const Role = z.enum(['player', 'principal']);
/** The three-way choice from the applicant card table. */
export const PrincipalPreference = z.enum(['would_like', 'open_to', 'would_rather_not']);
export const ProfessionalOrAmateur = z.enum(['professional', 'amateur']);
export const MaterialKind = z.enum(['excerpt', 'piece_1', 'piece_2', 'explanation']);
/**
 * Whether somebody plays in an orchestra now, used to, or never has.
 *
 * Two of the three lead to the same follow-up questions and the third skips
 * them, which is exactly how the form the orchestra used last year branches.
 */
export const OrchestraHistory = z.enum(['current', 'previous', 'never']);
/**
 * A check that fails for any reason other than a definite provider answer is
 * `unknown` and is retried. Only private, deleted and no_embed trigger the
 * "please replace this link" email — the cost of a false alarm is an applicant
 * re-uploading a working video during a deadline week.
 */
export const LinkStatus = z.enum(['ok', 'private', 'deleted', 'no_embed', 'unknown']);
export const VideoProvider = z.enum(['youtube', 'vimeo']);
export const OfferKind = z.enum(['place', 'principal', 'reserve_place']);
/** `accepted_place_only` is valid only for a principal offer. */
export const OfferResponse = z.enum([
    'accepted', 'accepted_place_only', 'declined', 'no_response',
]);
export const DraftKind = z.enum([
    'application', 'adjudication', 'section_ranking', 'review_comment', 'audition_setup',
]);
export const DataRequestKind = z.enum([
    'access', 'rectification', 'erasure', 'portability',
]);
export const ReleaseBatchKind = z.enum(['outcome_wave', 'section_ordering']);
export const SnapshotReason = z.enum([
    'approved', 'edited_after_sign_off', 'ordering_published',
]);
//# sourceMappingURL=domain.js.map